import { useState, useEffect, useRef } from 'react';
import { nanoid } from 'nanoid';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import { MonoSpace, MultiSpaces } from './space.js';
import Emitter from '@/helpers/emitter.js';
import { getPlaceData } from '@/helpers/position.js';
import { useZusModalStore } from '@/helpers/modal.js';
import { useZusHomeStore } from '@/helpers/context';

function Pin({ marker, latlng }) {
  const pinRef = useRef();
  const parentRef = useRef();
  const [pinId] = useState(nanoid());
  const [classes] = useState('');
  const [openSpaces, setOpenSpaces] = useState(marker?.openSpaces);
  const [spaces, setSpaces] = useState(marker?.spaces || []);
  const pinIdOpen = useSearchZustandStore((state) => state.pinIdOpen);
  const { ua } = useZusHomeStore.getState();

  const [isHover, setIsHover] = useState();

  function emitterHover(value) {
    setIsHover(value);
  }
  function renderText() {
    return <span className="text">{marker.text}</span>;
  }

  function renderSpaces() {
    if (!openSpaces) {
      return null;
    }
    if (marker.fromCluster && ua.isMobile) return null;

    if (spaces.length === 1) return <MonoSpace space={spaces[0]} />;
    return <MultiSpaces {...{ spaces }} />;
  }

  useEffect(() => {
    if (!marker.fromCluster) {
      if (pinIdOpen !== pinId) {
        setSpaces([]);
        if (!ua.isMobile) {
          setOpenSpaces(false);
        } else {
          useZusModalStore.setState({ zusModal1: null });
        }
      } else if (pinIdOpen === pinId) {
        const { spaces: spacesZus } = useSearchZustandStore.getState().pinData;
        if (!ua.isMobile) {
          setSpaces(spacesZus);
          setOpenSpaces(true);
        } else {
          let contentSpaceDetails;
          if (spacesZus.length === 1) contentSpaceDetails = <MonoSpace space={spacesZus[0]} />;
          else contentSpaceDetails = <MultiSpaces {...{ spaces: spacesZus }} />;
          setTimeout(() => {
            useZusModalStore.setState({ zusModal1: contentSpaceDetails });
          });
        }
      }
    } else if (ua.isMobile) {
      if (!pinIdOpen) useZusModalStore.setState({ zusModal1: null });
      else useZusModalStore.setState({ zusModal1: <MultiSpaces {...{ spaces }} /> });
    }
  }, [pinIdOpen]);

  useEffect(() => {
    Emitter.on(
      `searchresultsspacehoversignalemittospace${marker.iid}`,
      emitterHover,
    );
    Emitter.on(
      `searchresultsspacehoversignalemittodistrict${marker.iid}`,
      emitterHover,
    );
    Emitter.on(
      `searchresultsspacehoversignalemittocity${marker.iid}`,
      emitterHover,
    );

    return () => {
      Emitter.off(
        `searchresultsspacehoversignalemittospace${marker.iid}`,
        emitterHover,
      );
      Emitter.off(
        `searchresultsspacehoversignalemittodistrict${marker.iid}`,
        emitterHover,
      );
      Emitter.off(
        `searchresultsspacehoversignalemittocity${marker.iid}`,
        emitterHover,
      );
    };
  }, []);

  useEffect(() => {
    if (openSpaces) {
      if (parentRef.current) {
        parentRef.current.style.zIndex = 'inherit';
      }
    } else if (parentRef.current) {
        parentRef.current.style.zIndex = null;
      }
  }, [openSpaces]);

  async function onClick(e) {
    e.stopPropagation();

    const map = useSearchZustandStore.getState()?.mapData?.map;
    if (!map) return console.log('map pin - ERROR BIG BIG MAP NOT EXISTED');
    if (marker.fromCluster) return console.log('map pin - PIN SPACE OPEN BY CLUSTER');
    if (openSpaces) return console.log('map pin - PIN SPACE OPENED');

    if (marker.bySpace) {
      const spaceRefs = [marker?.iid];
      useSearchZustandStore.setState({
        pinData: null,
        pinEvent: { action: 'pinclick', data: { spaceRefs, pinId } },
      });
    } else if (marker.spacesCount === 1 || marker.isDistrict) {
        Emitter.emit('search_map_build_moveMap', { latlng, zoom: 15 });
      } else {
        const resPlaceId = await getPlaceData({ place_id: marker.iid });
        if (!resPlaceId) return alert('Please contact We Are Scene support, you suppose not to see that');

        Emitter.emit('search_map_build_moveMap', { ...resPlaceId.location });
      }
    return true;
  }

  return (
    <div ref={parentRef}>
      <div
        ref={pinRef}
        className={`pin ${marker.classes ?? ' '} ${classes} ${isHover ? 'hover ' : ''}`}
        id={`pin_${marker.iid}`}
        onClick={(e) => onClick(e)}
      >
        {renderText()}
        {!openSpaces || renderSpaces()}
      </div>
    </div>
  );
}

export default Pin;
